import React, { useState } from "react";
import { connect } from "react-redux";
import { compose } from "redux";
import { Grid } from "@material-ui/core";
import { ButtonIcon } from "@loanbossinc/component-library";

import { favoriteTerm } from "../../../../dealAnalysis/dealAnalysis.store";
import "./styles.css";

const Header = ({ term, favorited, favoriteTerm, dealId }) => {
  const favorite = () => {
    favoriteTerm({ dealId, term });
  };

  return (
    <Grid item xs={12}>
      <div className="proceeds-card-header-container">
        <span className="proceeds-card-header-star-wrapper" onClick={() => favorite()}>
          <ButtonIcon
            iconName={`${favorited ? "star" : "star_border"}`}
            buttonSize="sm-fluid"
          />
        </span>
        {term}
        {" "}
        Year
      </div>
    </Grid>
  );
};

const mapStateToProps = ({ }) => ({ });

export default compose(connect(mapStateToProps,
  {
    favoriteTerm
  }))(Header);
